module.exports = __webpack_public_path__ + "static/img/p4.8f9bfc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p4.jpg
// module id = IjXa
// module chunks = 0